import React from "react";

export interface ModularPageComponentProps {
  children: React.ReactNode;
  noPadding?: boolean;
}

export const ModularPageComponent = ({ children, noPadding }: ModularPageComponentProps) => {
  return (
    <div className="module" {...(noPadding ? { "data-no-padding": "" } : {})}>
      <div className="moduleWrapper">{children}</div>
    </div>
  );
};
